<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1">
    <div class="absolute top-right">
      <button
        @click="$router.push('/admin/products/new')"
        type="button"
        class="btn-primary"
      >
        Add New
      </button>
    </div>
    <div>
      <ul
        role="list"
        class="space-y-12 sm:space-y-0 sm:-mt-8 lg:mt-3 lg:gap-x-8 lg:space-y-8"
        v-if="courses.length > 0"
      >
        <li
          v-for="item in courses"
          :key="item._id"
          class="sm:py-8 shadow rounded mb-5"
        >
          <div
            class="space-y-4 sm:grid lg:flex sm:items-start sm:gap-6 sm:space-y-0"
          >
            <div class="mx-5">
              <img
                class="w-48 inline-block object-contain p-3 self-center"
                :src="item.image"
                :alt="item._id"
              />
            </div>
            <div class="w-full px-5">
              <div class="space-y-1 w-full">
                <div
                  class="flex justify-between text-xl font-bold leading-6 space-y-1"
                >
                  <h3 class="mb-0">{{ item.title }}</h3>
                  <h3 class="mb-0">
                    {{
                      item.price == 0
                        ? 'Free'
                        : item.currency == 'USD'
                        ? `$${item.price}`
                        : item.price
                    }}
                  </h3>
                </div>
                <div class="text-lg">
                  <p class="text-gray-900 mb-1">
                    {{ item.description }}
                  </p>
                  <!-- <p class="text-gray-800">ESTD: {{ item.estdTime }}</p> -->
                </div>
                <div class="border-t pt-2 flex justify-end space-x-5">
                  <router-link
                    :to="`/admin/products/${item._id}`"
                    type="button"
                    class="inline-flex items-center px-4 py-2 border-2 border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primaryColor hover:bg-secondaryColor focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 hover:no-underline"
                  >
                    Edit
                  </router-link>
                  <router-link
                    :to="`/admin/products/${item._id}/lessons`"
                    type="button"
                    class="bg-transparent hover:bg-blue text-blue-dark font-semibold border-2 py-2 px-4 border border-blue rounded hover:no-underline"
                  >
                    View Lessons
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="rounded-md bg-blue-50 p-4">
        <div v-if="courses.length <= 0" class="flex">
          <div class="flex-shrink-0">
            <!-- Heroicon name: solid/information-circle -->
            <svg
              class="h-5 w-5 text-blue-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="ml-3 flex-1 md:flex md:justify-between">
            <p class="text-sm text-blue-700">
              There's no courses created by the creator right now.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import courseAPI from '@/services/course';
import store from '@/store';
import utils from '@/services/utils';

export default {
  name: 'course',
  layout: 'admin',
  store,
  data() {
    return {
      courses: [],
      open: false,
    };
  },
  async mounted() {
    store.commit('toggleLoading', true);
    courseAPI
      .getCourses()
      .then((data) => {
        store.commit('toggleLoading', false);
        this.courses = data.courses;
      })
      .catch((error) => {
        store.commit('toggleLoading', false);
        if (error.response.status === 401) {
          utils.setStatusMsg(
            this,
            'Unauthorized access, redirected to implicit',
          );
          this.$router.push({ path: '/' });
        }
        console.log({ error });
      });
  },
  methods: {
    copyInviteLink(topicId, index) {
      const link = `https://sites.recap.ai/m/member?t=${topicId}`;
      navigator.clipboard.writeText(link).then(
        () => {
          this.items[index].isCopied = true;
          // eslint-disable-next-line
          setTimeout(() => {
            this.items[index].isCopied = false;
          }, 3000);
          console.log('Async: Copying to clipboard was successful!');
        },
        (err) => {
          console.error('Async: Could not copy text: ', err);
        },
      );
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
</style>
